import Reveal from "./Reveal";
import { whatsappLink } from "../config";
import { User, CalendarHeart, Check } from "lucide-react";

const offerings = [
  {
    icon: User,
    title: "Sesiones individuales",
    desc: "Un encuentro personal, presencial u online, centrado en tus dudas y necesidades concretas del momento.",
    points: [
      "Atención 100% personalizada",
      "Resolución de dudas y miedos",
      "Recomendaciones y herramientas prácticas",
      "Espacio seguro y sin juicios",
    ],
  },
  {
    icon: CalendarHeart,
    title: "Planes especializados",
    desc: "Un acompañamiento continuado a lo largo de tu etapa, con seguimiento cercano y contenidos a tu medida.",
    points: [
      "Seguimiento durante toda la etapa",
      "Plan adaptado a tu proceso",
      "Acompañamiento entre sesiones",
      "Materiales y recursos exclusivos",
    ],
  },
];

export default function HowIAccompany() {
  return (
    <section
      id="how"
      data-testid="how-i-accompany-section"
      className="py-24 md:py-32 bg-crema"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <p className="font-sans text-xs tracking-[0.35em] uppercase text-terracota mb-5">
            Cómo te acompaño
          </p>
          <h2 className="font-serif font-light text-4xl md:text-5xl text-ciruela leading-tight tracking-tight">
            Dos formas de <span className="italic text-terracota">caminar juntas</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mt-14">
          {offerings.map((o, i) => (
            <Reveal key={o.title} delay={i * 120}>
              <div
                data-testid={`offering-${i === 0 ? "individual" : "planes"}`}
                className="h-full rounded-[32px] bg-gradient-to-br from-ambar/40 to-rosa/20 border border-rosa/30 p-9 md:p-11"
              >
                <div className="h-14 w-14 rounded-2xl bg-ciruela flex items-center justify-center text-crema">
                  <o.icon className="h-7 w-7" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-3xl md:text-4xl text-ciruela mt-7">{o.title}</h3>
                <p className="font-body text-base text-ciruela-dark/75 mt-4 leading-relaxed">
                  {o.desc}
                </p>
                <ul className="mt-7 space-y-3">
                  {o.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 font-body text-[15px] text-ciruela-dark/80">
                      <Check className="h-5 w-5 text-terracota shrink-0 mt-0.5" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href={whatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`offering-cta-${i}`}
                  className="inline-block mt-9 font-sans text-sm font-medium text-ciruela border-b-2 border-terracota pb-1 hover:text-terracota transition-colors"
                >
                  Más información →
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
